
import { useState, useEffect } from 'react';
import { RedemptionOptionsConfig, RedeemedItem } from '@/types/redemptionTypes';

export const useRedemptionStats = () => {
  const [stats, setStats] = useState({
    activeUsers: 0,
    totalRedeemed: 0,
    totalUsers: 0,
    redemptionMethods: [
      { name: 'Cash', count: 0 },
      { name: 'Gift Card', count: 0 },
      { name: 'Promo Code', count: 0 }
    ],
    redemptionConfig: {
      enableCashRedemption: true,
      enableGiftCardRedemption: true,
      enablePromoCouponRedemption: true,
      cashRedemptionMinAmount: 10,
      cashRedemptionMaxAmount: 1000,
      cashPointValue: 1,
      giftCardPrefix: 'GC',
      giftCardMinAmount: 10,
      giftCardMaxAmount: 500,
      giftCardPointValue: 1,
      promoCodeFormat: 'CODE139' as const,
      promoCodeMinAmount: 5,
      promoCodeMaxAmount: 200,
      promoCodePointValue: 1
    }
  });

  useEffect(() => {
    // In a real app, this would fetch data from your API
    const fetchStats = async () => {
      // Simulated data - replace with actual API calls
      const mockRedeemedItems: RedeemedItem[] = [
        { id: '1', userId: '1', username: 'user1', email: 'user1@example.com', date: '2025-04-19', type: 'CASH', amount: 100, status: 'COMPLETED', pointValueAtRedemption: 100 },
        { id: '2', userId: '2', username: 'user2', email: 'user2@example.com', date: '2025-04-19', type: 'GIFT_CARD', amount: 50, status: 'COMPLETED', pointValueAtRedemption: 50 },
        { id: '3', userId: '3', username: 'user3', email: 'user3@example.com', date: '2025-04-19', type: 'PROMO_CODE', amount: 25, status: 'COMPLETED', pointValueAtRedemption: 25 },
        // Add more mock data as needed
      ];

      const calculateStats = (items: RedeemedItem[]) => {
        const methodCounts = {
          CASH: 0,
          GIFT_CARD: 0,
          PROMO_CODE: 0
        };

        const totalRedeemed = items.reduce((sum, item) => {
          if (item.status === 'COMPLETED') {
            methodCounts[item.type]++;
            return sum + item.amount;
          }
          return sum;
        }, 0);

        setStats(prev => ({
          ...prev,
          activeUsers: 150, // Mock active users count
          totalUsers: 200, // Mock total users count
          totalRedeemed,
          redemptionMethods: [
            { name: 'Cash', count: methodCounts.CASH },
            { name: 'Gift Card', count: methodCounts.GIFT_CARD },
            { name: 'Promo Code', count: methodCounts.PROMO_CODE }
          ]
        }));
      };

      calculateStats(mockRedeemedItems);
    };

    fetchStats();
  }, []);

  return stats;
};
